import { useEffect, useRef, useState } from "react";

import countriesJson from "src/utils/countries.json";

export const useSelectedCountry = (
    countriesData: any[],
    contextCountry?: string | null
) => {
    const [selectedCountry, setSelectedCountry] = useState<string | null>(null);

    const prefilledFromQueryRef = useRef(false);

    useEffect(() => {
        if (contextCountry != null) {
            setSelectedCountry(contextCountry);
            return;
        }

        const params = new URLSearchParams(
            window.location.search
        );

        const codeParam =
            params.get("country") ||
            params.get("c");

        if (codeParam && countriesData.length > 0) {
            const mapped = countriesJson.find(
                (c: any) =>
                    String(c.code).toUpperCase() ===
                    String(codeParam).toUpperCase()
            )?.name;

            if (
                mapped &&
                countriesData.some(
                    (c) => c.country_name === mapped
                )
            ) {
                prefilledFromQueryRef.current = true;
                setSelectedCountry(mapped);
                return;
            }
        }

        if (
            !prefilledFromQueryRef.current &&
            !selectedCountry &&
            countriesData.length > 0
        ) {
            setSelectedCountry(
                countriesData[0].country_name
            );
        }
    }, [
        contextCountry,
        countriesData,
        selectedCountry,
    ]);

    return {
        selectedCountry,
        setSelectedCountry,
    };
};